import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps__step-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h4 h4--b" }, " Who from The Boundary Live is involved in this project? ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-24" }, " All fields are required unless indicated as optional. ", -1 /* HOISTED */)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = {
  class: "button button--fill",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "form form--fixed-fields",
      onSubmit: _withModifiers($setup.updateForm, ["prevent"])
    }, [
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.business_development,
        type: "checkboxes-dropdown",
        "input-id": "business-development",
        name: "business-development",
        label: "Business Development Lead",
        placeholder: "Search",
        options: $setup.filtered_business_developers,
        "selection-label": $setup.selected_business_developers_label,
        "filter-key": "business_development",
        "filter-search": $setup.form_fields.business_development.search_query,
        "active-values": $setup.form_fields.business_development.values,
        required: true,
        errors: $setup.form_errors.business_development || null,
        "onUpdate:value": _cache[0] || (_cache[0] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'business_development' ))
      }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
      _createVNode($setup["InputComponent"], {
        value: $setup.form_fields.project_manager,
        type: "checkboxes-dropdown",
        "input-id": "project-manager",
        name: "project-manager",
        label: "Project Manager",
        "sub-label": "Optional",
        placeholder: "Search",
        options: $setup.filtered_project_managers,
        "selection-label": $setup.selected_project_managers_label,
        "filter-key": "project_manager",
        "filter-search": $setup.form_fields.project_manager.search_query,
        "active-values": $setup.form_fields.project_manager.values,
        required: false,
        errors: $setup.form_errors.project_manager || null,
        "onUpdate:value": _cache[1] || (_cache[1] = ( value ) => $setup.handleCheckboxDropdownUpdate( value, 'project_manager' ))
      }, null, 8 /* PROPS */, ["value", "options", "selection-label", "filter-search", "active-values", "errors"]),
      _createElementVNode("button", _hoisted_5, " Save " + _toDisplayString($props.stepTitle), 1 /* TEXT */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
  ]))
}